// Resolve the dotlottie-web wasm player next to this module. Isolated in its own
// file because `import.meta.url` cannot be transformed by the CommonJS-targeted
// Jest transformers — the module is mocked in tests via `moduleNameMapper`
// (see `jest.preset.js`), so `import.meta` never reaches the test runtime.
// Kept as a query-free specifier so it matches dotlottie-web's strict `exports`
// map under webpack's asset-module resolution.
export const dotlottiePlayerWasmUrl = new URL(
  '@lottiefiles/dotlottie-web/dotlottie-player.wasm',
  import.meta.url
).href;
